import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceService } from 'src/app/business-service/invoice/invoice.service';
import { PaymentService } from 'src/app/business-service/payments/payment.service';
import { INVOICE_TYPES, TABLE_OPTION_VALUES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-invoice-payments',
  templateUrl: './invoice-payments.component.html',
  styleUrls: ['./invoice-payments.component.scss'],
})
export class InvoicePaymentsComponent implements OnInit {

  @Input() leadId: any;

  doesInvoiceExists: boolean = false;

  clientInvoice: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  clientInvoiceColumns: any = [
    { key: "invoiceId", colName: "ID", showColumn: true, routePath: '/invoice/details/' },
    { key: "invoiceDate", colName: "Invoice Date", showColumn: true, formatter: "date" },
    { key: "dueDate", colName: "Due Date", showColumn: true, formatter: "date" },
    { key: "formattedTotalAmount", colName: "Amount", showColumn: true},
    { key: "formattedBalanceAmount", colName: "Balance", showColumn: true },
    { key: "status", colName: "Status", showColumn: true }
  ]

  invoiceOptionsValues: any =
    {
      idKey: 'invoiceId',
      options: [
        {
          value: "View",
          path: "details"
        },
        {
          value: "Edit",
          path: "edit"
        },
        {
          value: "Add Payment",
          path: "addPayment"
        },
        {
          value: "Delete",
          path: "delete"
        }
      ]
    }

  allPaymentsOfLead: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  allPaymentsOfLeadColumns: any = [
    {
      key: "paymentId",
      colName: "ID",
      showColumn: true,
    },
    {
      key: "paymentMethod",
      colName: "Method",
      showColumn: true,
    },
    {
      key: "paymentDate",
      colName: "Date",
      showColumn: true,
      formatter: 'date'
    },
    {
      key: "requestedAmount",
      colName: "Paid",
      showColumn: true,
      formatter: "currency : INR"
    },
    {
      key: "updatedBalanceAmount",
      colName: "Total Advance Received",
      showColumn: true,
      formatter: "currency : INR"
    },
    {
      key: "referenceNumber",
      colName: "Ref Number",
      showColumn: true
    }
  ];

  // Vendor Invoice
  allVendorInvoiceData: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  allVendorInvoiceDataColumns: any = [
    {
      key: "invoiceId",
      colName: "ID",
      showColumn: true,
      routePath: '/vendor-payments/details/',
      isDisabled: true
    },
    {
      key: "fullName",
      colName: "Vendor Name",
      showColumn: true,
      isDisabled: true
    },
    {
      key: "serviceType",
      colName: "Service Type",
      showColumn: true
    },
    {
      key: "tripStartDate",
      colName: "Trip State Date",
      showColumn: true,
      formatter: "date"
    },
    {
      key: "tripEndDate",
      colName: "Trip End Date",
      showColumn: false,
      formatter: "date"
    },
    {
      key: "vendorId",
      colName: "Vendor ID",
      showColumn: true,
      routePath: '/contacts/vendor-details/'
    },
    {
      key: "vendorId",
      colName: "Vendor ID",
      showColumn: true,
      routePath: '/contacts/vendor-details/'
    },
    {
      key: "invoiceDate",
      colName: "Invoice Date",
      showColumn: true,
      formatter: "date"
    },
    {
      key: "dueDate",
      colName: "Due Date",
      showColumn: true,
      formatter: "date"
    },
    {
      key: "formattedTotalAmount",
      colName: "Amount",
      showColumn: true,
      isDisabled: true
    },
    {
      key: "formattedBalanceAmount",
      colName: "Balance",
      showColumn: true,
    },
    {
      key: 'viewDocument',
      colName: 'Document',
      showColumn: true,
      emitRowOnClick: true
    },
    {
      key: "status",
      colName: "Status",
      showColumn: true,
      isDisabled: true
    }
  ]

  vendorInvoiceOptionsValues: any = {
    idKey: "invoiceId",
    options: [
      {
        value: "View",
        path: TABLE_OPTION_VALUES.VIEW
      },
      {
        value: "Edit",
        path: TABLE_OPTION_VALUES.EDIT
      },
      {
        value: "Add Payment",
        path: TABLE_OPTION_VALUES.ADD_PAYMENT
      },
      {
        value: "Audit History",
        path: TABLE_OPTION_VALUES.SHOW_AUDIT
      },
      {
        value: "Delete",
        path: TABLE_OPTION_VALUES.DELETE
      }
    ]
  }

  constructor(
    private _reloadService: ComponentReloadService,
    private _invoiceService: InvoiceService,
    private _paymentService: PaymentService,
    private _modalPopupService: ModalsService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _router: Router
  ) { }

  ngOnInit() {
    this._reloadService.reloadInvoices$.subscribe(() => {
      this.getDefaultInvoicesForLead()
    });
    this._reloadService.reloadPayment$.subscribe(() => {
      this.getDefaultPayments()
    });

    this.getDefaultInvoicesForLead();
    this.getDefaultPayments();
    this.getDefaultVendorInvoicesForLead();
  }

  // Get defalut invoices for lead
  getDefaultInvoicesForLead() {
    this._invoiceService.getAllInvoiceForLead(this.leadId, null, null, null).subscribe((data) => {
      this.clientInvoice = data;
      this.clientInvoice.data = this.clientInvoice.data.map((row: any) => {
        const currency = row.currencyCode || 'INR';
        return {
          ...row,
          formattedBalanceAmount: this._globalService.formatCurrency(row.balanceAmount, currency),
          formattedTotalAmount: this._globalService.formatCurrency(row.totalAmount, currency)
        };
      });
      if (data?.data?.length > 0) {
        this.doesInvoiceExists = true;
      }
    })
  }

  // Invoice funcitons

  addInvoiceForClinet() {
    this._modalPopupService.openInvoiceForm(null, this.leadId, null, () => {
      this.getDefaultInvoicesForLead();
    })
  }

  async deleteInvoiceRow(data: any) {
    if (await this._globalService.confirmActionPopup("Confirm To Delete Invoice")) {
      this._invoiceService.deleteInvoice(data).subscribe((data) => {
        this._responseNotificationService.showMessage("Invoice deleted successfully")
      })
    }
  }

  editInvoiceOpen(data: any) {
    this._modalPopupService.openInvoiceForm(data, null, null, () => {
    })
  }

  viewInvoice(data: any) {
    this._router.navigate([`invoice/details/${data}`]);
  }

  addPaymentForInvoice(id: any) {
    this._invoiceService.getInvoiceDetails(id).subscribe((data) => {
      if (data.balanceAmount > 0) {
        this._modalPopupService.openPaymentForm(INVOICE_TYPES.CUSTOMER, id, false)
      } else {
        this._globalService.customAlert("All payments settled!");
      }
    })
  }

  getDefaultPayments() {
    this._paymentService.getAllPaymentsOfLead(this.leadId, null, null, null).subscribe((data) => {
      this.allPaymentsOfLead = data;
    })
  }

  addPaymentToLead() {
    this._modalPopupService.openPaymentForm(INVOICE_TYPES.CUSTOMER, null, false, this.leadId)
  }

  refundPaymentToLead() {
    this._modalPopupService.openPaymentForm(INVOICE_TYPES.CUSTOMER, null, true, this.leadId)
  }

  // Vendor invoice funtions

  getDefaultVendorInvoicesForLead() {
    this._invoiceService.getAllVendorInvoiceForLead(this.leadId, null, null, null).subscribe((data) => {
      this.allVendorInvoiceData = data;
      this.allVendorInvoiceData.data = this.allVendorInvoiceData.data.map((row: any) => {
        const currency = row.currencyCode || 'INR';
        return {
          ...row,
          fullName: `${row.firstName || ''} ${row.lastName || ''}`.trim(),
          viewDocument: "View",
          formattedBalanceAmount: this._globalService.formatCurrency(row.balanceAmount, currency),
          formattedTotalAmount: this._globalService.formatCurrency(row.totalAmount, currency)
        };
      });
    }) 
  }

  openVendorInvoiceForm() {
    this._modalPopupService.openVendorInvoice(null, this.leadId, null);
  }

  async deleteVendorInvoiceRow(data: any) {
    if (await this._globalService.confirmActionPopup("Confirm To Delete Invoice")) {
      this._invoiceService.deleteVendorInvoice(data).subscribe((data) => {
        this._responseNotificationService.showMessage("Invoice deleted successfully");
        this._reloadService.triggerInvoicesReload();
      })
    }
  }

  editVendorInvoiceOpen(id: any) {
    this._paymentService.getAllPaymentsForVendorInvoice(id, null, null, null).subscribe((data) => {
      if (Array.isArray(data?.data) && data?.data.length > 0) {
        this._globalService.customAlert("Invoice cannot be edited as payments have been made against it.");
        return;
      } else {
        this._modalPopupService.openVendorInvoice(id, null, null);
      }
    });
  }

  viewVendorInvoice(data: any) {
    this._router.navigate([`vendor-payments/details/${data}`]);
  }

  vendorRowCellClicked(event: any) {
    const clickedItem = event?.clickedItem;
    const row = event?.row;
    if (clickedItem === 'viewDocument') {
      this._modalPopupService.openImageModal(row.documentFilePath)
    }
  }

  addPaymentForVendorInvoice(invoiceId: any) {
    this._invoiceService.getVendorInvoiceDetails(invoiceId).subscribe((data) => {
      if (data.balanceAmount > 0) {
        this._modalPopupService.openPaymentForm(INVOICE_TYPES.VENDOR, invoiceId, false)
      } else {
        this._globalService.customAlert("All payments settled!");
      }
    })
  }
}
